import React from 'react';
import { Typography } from 'antd';
import { LockIcon } from '../../components/Icons';

import styles from './styles.module.css';

const { Title, Text } = Typography;

export const Error: React.FC = () => {
    return (
        <section className={styles.root}>
            <div className={styles.errorPage}>
                <LockIcon />
                <div className={styles.textContent}>
                    <Text className={styles.title}>Доступ запрещен</Text>
                    <Text className={styles.description}>
                        У вас нет доступа к этой странице
                    </Text>
                </div>
            </div>
        </section>
    );
};
